import { useQuery } from '@apollo/client';

import { MILESTONES } from '../graphql/query/milestonesQuery.graphql';

export const useMilestonesQuery = (eventId: string | null) => {
  return useQuery(MILESTONES, {
    skip: eventId === null,
    variables: { eventId: eventId ?? '' },
  });
};
